import React, { useState } from "react";
import { toast } from "sonner";
import { api, formatErr } from "../../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";

const FIELDS = [
  ["title_ru", "Название RU"], ["title_en", "Название EN"], ["title_cn", "Название CN"],
  ["category", "Категория"], ["metric", "Метрика / подпись"],
];

export default function PortfolioEditDialog({ item, onClose, onSaved }) {
  const [form, setForm] = useState({
    title_ru: item.title_ru || "", title_en: item.title_en || "", title_cn: item.title_cn || "",
    category: item.category || "", metric: item.metric || "", sort_order: item.sort_order || 0,
  });
  const [saving, setSaving] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try { await api.put(`/admin/portfolio/${item.id}`, form); toast.success("Сохранено"); onSaved(); }
    catch (err) { toast.error(formatErr(err?.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg bg-[#0E0E16] border-[#D4AF37]/30 text-gray-100" data-testid="portfolio-edit-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl">✏️ Работа портфолио</DialogTitle>
          <DialogDescription className="text-gray-400">Подписи на трёх языках для публичного сайта.</DialogDescription>
        </DialogHeader>
        <form onSubmit={save} className="space-y-3">
          {FIELDS.map(([k, l]) => (
            <div key={k}>
              <label>{l}</label>
              <input value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })} className="mt-1" data-testid={`portfolio-${k}-input`} />
            </div>
          ))}
          <div className="flex gap-3 justify-end pt-2">
            <button type="button" onClick={onClose} className="btn-outline" data-testid="portfolio-cancel-btn">Отмена</button>
            <button type="submit" disabled={saving} className="btn-gold" data-testid="portfolio-save-btn">{saving ? "…" : "Сохранить"}</button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
